const APIS = {
  BRANCH: "/logisticservice/api/branch/",
  USER_BRANCH: "/usermanagementservice/api/branch/",
  BRANCH_COMMISSION: "/logisticservice/api/branch-commission/",
  STAFF: "/logisticservice/api/staff/",
  USER: "/usermanagementservice/api/user/",
  SERVICE_TYPE: "/logisticservice/api/service-type/",
  USER_PROFILE: "/logisticservice/api/user-profile/",
  LOCATION: "/logisticservice/api/location/",
  WAREHOUSE: "/logisticservice/api/warehouse/",
  DELIVERY_CHARGE: "/logisticservice/api/branch-charge/",
  BANK_DETAIL: "/usermanagementservice/api/bank-detail/",
  PRODUCT_TYPE: "logisticservice/api/product-type/",
  DELIVERY_CHARGE_TEMPLATE: "logisticservice/api/delivery-charge-template/",
};
export default APIS;
